import React, { Component } from 'react';
import { Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2, Form, FormGroup } from "reactstrap";
import { api, filterHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { stringHelper, constant as constants } from "../helpers";

const emptyEmailAddress = {
  email: '',
  emailNotifications: [], 
  receiveAllEmails: false
}

const getMaintenanceTypes = () =>
  api
    .fetch("Reference/MaintenanceTypes")
    .then(response => {
      return {
        maintenanceTypeList: response.data
      };
    })
    .catch(x => console.error(x));

export default class EmailListAdmin extends Component {
  static displayName = EmailListAdmin.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      emailAddress: null,
      maintenanceTypeList: [],
      filters: [],
      pagedList: null,
      sortColumn: "Name",
      sortAscending: true,
      newEmailAddress:  emptyEmailAddress
    }
    this.refreshList = this.refreshList.bind(this);
    this.onEditEmailAddress = this.onEditEmailAddress.bind(this);
    this.onCancelEditEmailAddress = this.onCancelEditEmailAddress.bind(this);
    this.onSaveNewEmailAddress = this.onSaveNewEmailAddress.bind(this);
    this.onUpdateEmailAddress = this.onUpdateEmailAddress.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.toggleEmailNotification = this.toggleEmailNotification.bind(this);
  }

  componentDidMount() {
    Promise.all([getMaintenanceTypes()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        this.onChangeFilter({
          filterName: "activeOnly",
          value: true,
          filteredDisplay: "Active Only"
        });
      });
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/EmailAddresses", payload)
      .then(response => {
        if (response && response.data) {
          let formattedDataSource = _.map(response.data.dataSource, item => {
            return {
              id: item.id,
              email: stringHelper.nullableString(item.email),
              deactivatedAt: item.deactivatedAt,
              emailNotifications: item.emailNotifications,
              receiveAllEmails: item.receiveAllEmails
            }
          });
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: formattedDataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            message: null,
            messageColor: null,
            isMessageVisible: false,
            emailAddressIsBeingEdited: false,
            emailAddress: null, 
            newEmailAddress: emptyEmailAddress
          });
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  onUpdateEmailAddress(emailAddress, emailAddressIndex) {
    if (emailAddress.email === "" || !stringHelper.emailIsValid(emailAddress.email)) {
      this.setState({ message: "Valid email address is required.", messageColor: "danger" });
      return;
    }
    if (emailAddress.email === emailAddress.pristine.email) {
      this.onCancelEditEmailAddress(emailAddressIndex);
      return;
    }
    let payload = {
      Id: emailAddress.id,
      Email: emailAddress.email,
      EmailNotifications: emailAddress.emailNotifications,
      ReceiveAllEmails: emailAddress.receiveAllEmails
    }

    api.post("Admin/CheckIfEmailExists", payload)
      .then(response => {
        if (response.data) {
          Alert.error(`${emailAddress.email} already exists.`);
              this.onCancelEditEmailAddress(emailAddressIndex)
        } else {
          api.post("Admin/SaveEmailAddress", payload)
          .then(response => {
            if (response.data.success) {
              Alert.success(`${emailAddress.email} has been saved.`)
              this.refreshList();
              this.props.refreshAll();
            } else {
              Alert.error("An error occurred.  The email address could not be added at this time.");
            }
          });
        }
      });   
  }

  onUpdateEmailNotification(emailAddress) {
    let formattedEmailNotifications;
    if (emailAddress.receiveAllEmails === true) {
      formattedEmailNotifications = _.map(emailAddress.emailNotifications, notification => {
        return {
          ...notification,
          markedForDeletion: true
        }
      } )
    } else {
      formattedEmailNotifications = emailAddress.emailNotifications.slice();
    }
    
    let receiveAllEmails = _.some(emailAddress.emailNotifications,  ['markedForRevive', true]) ? false :  emailAddress.receiveAllEmails;


    let payload = {
      Id: emailAddress.id,
      Email: emailAddress.email,
      EmailNotifications: formattedEmailNotifications,
      ReceiveAllEmails: receiveAllEmails
    }

    api.post("Admin/SaveEmailAddress", payload)
    .then(response => {
      if (response.data.success) {
        // Alert.success(`${emailAddress.email} has been saved.`)
        this.refreshList();
        this.props.refreshAll();
      } else {
        Alert.error("An error occurred.  The email address could not be updated at this time.");
      }
    });
  }  

  onSaveNewEmailAddress(emailAddress) {
    if (emailAddress.email === "" || !stringHelper.emailIsValid(emailAddress.email)) {
      this.setState({ message: "Valid email address is required.", messageColor: "danger" });
      return;
    }
    let payload = {
      Id: emailAddress.id,
      Email: emailAddress.email,
      EmailNotifications: emailAddress.emailNotifications,
      ReceiveAllEmails: emailAddress.receiveAllEmails
    }

    api.post("Admin/CheckIfEmailExists", payload)
      .then(response => {
        if (response.data) {
          Alert.error(`${emailAddress.email} already exists.`);
        } else {
          api.post("Admin/SaveEmailAddress", payload)
          .then(response => {
            if (response.data.success) {
              Alert.success(`${emailAddress.email} has been saved.`)
              this.refreshList();
              this.props.refreshAll();
            } else {
              Alert.error("An error occurred.  The email address could not be added at this time.");
            }
          });
        }
      });   
  }

  onDelete(emailAddressId) {
    if (!window.confirm(`Are you sure you'd like to delete this email address?`)) return;

    api.delete(`Admin/DeleteEmailAddress/${emailAddressId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Email address was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Email address cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the email address.")
      });
  }

  onRevive(emailAddressId) {
    api.post("Admin/ReviveEmailAddress", emailAddressId)
      .then(response => {
        if (response.data.success) {
          Alert.success("Email address was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Email address cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the email address."));
  }

  toggleEmailNotification(emailAddressIndex, emailAddressId, maintenanceTypeId) {
    let tempList = this.state.pagedList.list.slice();
    let emailAddressToUpdate = Object.assign({}, tempList[emailAddressIndex]);

    let indexToEdit = _.findIndex(emailAddressToUpdate.emailNotifications, function(x) {
      return (x.emailAddressId == emailAddressId && x.maintenanceTypeId == maintenanceTypeId)
    });
    let tempEmailNotificationsList = emailAddressToUpdate.emailNotifications.slice();
    if(indexToEdit >= 0) {
      if(tempEmailNotificationsList[indexToEdit].deactivatedAt == null) {
        tempEmailNotificationsList[indexToEdit].markedForDeletion = true;
      } else {
        tempEmailNotificationsList[indexToEdit].markedForRevive = true
      }
      emailAddressToUpdate = {
        ...emailAddressToUpdate,
        emailNotifications: tempEmailNotificationsList
      }
    } else {
      tempEmailNotificationsList.push(
        {
          EmailAddressId: emailAddressId,
          MaintenanceTypeId: maintenanceTypeId
        }
      )
      emailAddressToUpdate = {
        ...emailAddressToUpdate,
        emailNotifications: tempEmailNotificationsList, 
        receiveAllEmails: false // because some notifications have been selected
      }
    }
    this.onUpdateEmailNotification(emailAddressToUpdate);
  }

  onEditEmailAddress(emailAddressIndex) {
    let tempList = this.state.pagedList.list.slice();
    let snapShot = Object.assign({}, tempList[emailAddressIndex]);
    tempList[emailAddressIndex].editing = true;
    tempList[emailAddressIndex].pristine = snapShot;
    this.setState({
      pagedList: {
        ...this.state.pagedList,
        list: tempList,
      },
      emailAddress: tempList[emailAddressIndex]
    });
  }

  onCancelEditEmailAddress(emailAddressIndex) {
    let tempList = this.state.pagedList.list.slice();
    tempList[emailAddressIndex] = tempList[emailAddressIndex].pristine;
    this.setState({
      pagedList: {
        ...this.state.pagedList,
        list: tempList,
      },
      emailAddress: null,
    }, () => this.refreshList());
  }

  toggleReceiveAll(emailAddressIndex) {
    let tempList = this.state.pagedList.list.slice();
    let emailAddressToUpdate = Object.assign({}, tempList[emailAddressIndex]);
    emailAddressToUpdate = {
      ...emailAddressToUpdate,
      receiveAllEmails: !emailAddressToUpdate.receiveAllEmails
    };
    this.onUpdateEmailNotification(emailAddressToUpdate);
  }

  render() {
    return (
      <div>
        <Row>
          <Col><h5>Email List Administration</h5></Col>
        </Row>
        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null
        }
        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="email"
                  displayName=" Email"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form style={{ float: "right" }} inline>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Input
                  placeholder="Email Address To Add"
                  value={this.state.newEmailAddress.email}
                  onChange={(e) =>
                    this.setState({ 
                      newEmailAddress: {
                        ...this.state.newEmailAddress,
                        email: e.target.value
                      }
                    })
                  }
                  disabled={this.state.emailAddress ? true : false}
                />
              </FormGroup>
              <Button
                size="sm"
                onClick={() => this.onSaveNewEmailAddress(this.state.newEmailAddress)}
                color="primary"
                disabled={this.state.emailAddress ? true : false}
              >
                <FontAwesomeIcon icon="plus-circle" /> Add Email
              </Button>
            </Form>
          </Col>
        </Row>
        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Receive All Emails</th>
                  {this.state.maintenanceTypeList && this.state.maintenanceTypeList.map((mt) => (
                    <th key={mt.id}>{mt.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map((item, emailAddressIndex) => (
                    <tr key={`pg-${item.id}`}>
                      <td title="Double click to edit" onDoubleClick={() => this.onEditEmailAddress(emailAddressIndex)}>
                        {item.editing
                          ? <Input
                              autoFocus={true}
                              value={this.state.emailAddress.email}
                              onChange={(e) =>
                                this.setState({ 
                                  emailAddress: {
                                    ...this.state.emailAddress,
                                    email: e.target.value
                                  }
                                })
                              }
                              onBlur={() => this.onUpdateEmailAddress(this.state.emailAddress, emailAddressIndex)}
                            />
                          : item.email
                        }
                      </td>
                      <td>
                        <input
                          onChange={() => this.toggleReceiveAll(emailAddressIndex)}
                          type="checkbox"
                          checked={item.receiveAllEmails}
                        />
                      </td>
                      {this.state.maintenanceTypeList && this.state.maintenanceTypeList.map((mt) => (
                          <td key={`${item.id} ${mt.id}`}>
                            <input
                              onChange={() =>
                                this.toggleEmailNotification(emailAddressIndex, item.id, mt.id)
                              }
                              type="checkbox"
                              checked={_.some(item.emailNotifications, (i) =>
                                i.maintenanceTypeId == mt.id && i.deactivatedAt == null
                              )}
                            />
                          </td>
                      ))}                    
                      <td>
                        <ButtonGroup className="float-right">
                          {item.deactivatedAt === null ? (
                            <React.Fragment>
                              <Button
                                size="sm"
                                className="cbdmdDanger buttonGroupSpacing"
                                onClick={() => this.onDelete(item.id)}
                                disabled={this.state.emailAddress !== null}
                                title="Delete"
                              >
                                <FontAwesomeIcon
                                  icon="trash-alt"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer "
                                  title="Delete"
                                />
                              </Button>
                            </React.Fragment>
                          ) : (
                              <Button
                                size="sm"
                                className="cbdmdInfoTeal"
                                onClick={() => this.onRevive(item.id)}
                              > Revive
                              </Button>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                    <tr>
                      <td>
                        No Records available
                    </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EmailListAdmin.js